import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

(() => {
  const navEl = document.querySelector('.js-navbar-nav');
  const toggleButtonEl = document.querySelector('.js-navbar-toggle-button');
  const menuEl = document.querySelector('.js-navbar-menu');

  const showMenu = e => {
    e.preventDefault();
    menuEl.classList.add('show');
    navEl.classList.add('dark');
    toggleButtonEl.classList.add('active');
    disableBodyScroll(menuEl);
  };

  const closeMenu = e => {
    e.preventDefault();
    menuEl.classList.remove('show');
    navEl.classList.remove('active');
    navEl.classList.remove('dark');
    toggleButtonEl.classList.remove('active');
    enableBodyScroll(menuEl);
  };

  toggleButtonEl.addEventListener('click', e => {
    const show = menuEl.classList.contains('show');
    if (show) {
      closeMenu(e);
    } else {
      showMenu(e);
    }
  });
})();
